import { TFunction } from '@lyearn/i18n';
import { EditOutline, PlusCircle } from '@lyearn/icons';
import { JobMetaType } from '@/types/schema';

type GroupsChangeType = 'created' | 'updated';

type GroupsUpdateConfig = { [key in GroupsChangeType]: number };

const CONFIG = {
  created: {
    Icon: PlusCircle,
    labelKey: 'Group:BulkImport.NewGroup',
    suffixKey: 'Common:BulkImport.ImportData.added',
  },
  updated: {
    Icon: EditOutline,
    labelKey: 'Group:BulkImport.ExistingGroup',
    suffixKey: 'Common:BulkImport.ImportData.updated',
  },
};

export const getGroupBulkImportUpdateItems = (t: TFunction, updateData: JobMetaType) => {
  const groupsUpdateConfig: GroupsUpdateConfig = {
    created: updateData.userGroupMemberImportMetadata?.createdGroupsCount ?? 0,
    updated: updateData.userGroupMemberImportMetadata?.updatedGroupsCount ?? 0,
  };

  return Object.entries(groupsUpdateConfig)
    .filter(([_, count]) => count !== 0)
    .map(([key, count]) => {
      const { Icon, labelKey, suffixKey } = CONFIG[key as GroupsChangeType];

      return {
        Icon,
        label: t(labelKey, { count }),
        suffix: t(suffixKey),
      };
    });
};
